import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Settings, Trash2, Plus, Save } from "lucide-react";

const CloseReasonsAdmin = () => {
  const [reasons, setReasons] = useState([]);
  const [busy, setBusy] = useState(false);
  const load = async () => {
    const { data } = await api.get("/close-reasons");
    setReasons(data.reasons || []);
  };
  useEffect(() => { load(); }, []);

  const add = () => setReasons([...reasons, { id: `motivo-${Date.now()}`, label: "Novo motivo", reopenable: true }]);
  const remove = (id) => setReasons(reasons.filter((r) => r.id !== id));
  const upd = (id, f, v) => setReasons(reasons.map((r) => r.id === id ? { ...r, [f]: v } : r));

  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.put("/close-reasons", { reasons });
      setReasons(data.reasons);
      toast.success("Motivos salvos");
    } catch (e) { toast.error(e?.response?.data?.detail || "Erro"); }
    finally { setBusy(false); }
  };

  const reset = async () => {
    if (!window.confirm("Restaurar motivos padrão?")) return;
    const defaults = [
      { id: "desistencia", label: "Desistência do paciente/família", reopenable: true },
      { id: "outro_servico", label: "Internou em outro serviço", reopenable: false },
      { id: "obito", label: "Óbito", reopenable: false },
      { id: "sem_contato", label: "Perda de contato", reopenable: true },
      { id: "recusa", label: "Recusa de atendimento", reopenable: true },
      { id: "outro", label: "Outro motivo", reopenable: true },
    ];
    setReasons(defaults);
  };

  return (
    <div className="max-w-3xl mx-auto px-6 py-10">
      <div className="text-xs uppercase tracking-[0.18em] text-slate-500 flex items-center gap-1.5">
        <Settings className="w-3.5 h-3.5" /> Administração
      </div>
      <h1 className="font-display font-bold text-3xl text-[#0B2B62] tracking-tight mt-1">Motivos de encerramento sem internação</h1>
      <p className="text-slate-600 mt-2 text-sm">Personalize os motivos disponíveis ao consultor ao encerrar um caso sem internação. Marque quais permitem reabertura futura.</p>

      <div className="mt-6 bg-white border border-slate-200 rounded-xl p-6 space-y-3">
        {reasons.map((r) => (
          <div key={r.id} className="grid grid-cols-12 gap-2 items-center" data-testid={`reason-row-${r.id}`}>
            <input value={r.id} onChange={(e) => upd(r.id, "id", e.target.value)}
              className="col-span-3 px-2 py-1.5 border border-slate-300 rounded-md text-xs font-mono text-slate-600" placeholder="id" />
            <input value={r.label} onChange={(e) => upd(r.id, "label", e.target.value)}
              className="col-span-6 px-2.5 py-1.5 border border-slate-300 rounded-md text-sm" placeholder="Descrição" />
            <label className="col-span-2 flex items-center gap-1.5 text-xs text-slate-600">
              <input type="checkbox" checked={!!r.reopenable} onChange={(e) => upd(r.id, "reopenable", e.target.checked)} /> reabrir
            </label>
            <button onClick={() => remove(r.id)} className="col-span-1 text-red-600 hover:text-red-700 justify-self-end">
              <Trash2 className="w-4 h-4" />
            </button>
          </div>
        ))}
        <button data-testid="add-reason" onClick={add} className="inline-flex items-center gap-1.5 text-sm text-[#0B2B62] hover:underline font-semibold">
          <Plus className="w-4 h-4" /> Adicionar motivo
        </button>
      </div>

      <div className="mt-4 flex gap-2">
        <button data-testid="save-reasons" disabled={busy} onClick={save}
          className="inline-flex items-center gap-1.5 px-5 py-2.5 bg-[#0B2B62] text-white rounded-md font-semibold hover:bg-slate-800 disabled:opacity-60">
          <Save className="w-4 h-4" /> Salvar motivos
        </button>
        <button onClick={reset} className="px-4 py-2.5 border border-slate-300 text-slate-700 rounded-md text-sm">Restaurar padrão</button>
      </div>
    </div>
  );
};

export default CloseReasonsAdmin;
